var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-android-logo",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.6 9.48l1.3-2.25c0.13-0.23 0.05-0.52-0.18-0.65-0.23-0.13-0.52-0.05-0.65 0.18l-1.32 2.29c-1.01-0.44-2.13-0.7-3.35-0.7s-2.34 0.26-3.35 0.7l-1.32-2.29c-0.13-0.23-0.42-0.31-0.65-0.18-0.23 0.13-0.31 0.42-0.18 0.65l1.3 2.25c-2.13 1.09-3.6 3.13-3.6 5.52 0 0.28 0.22 0.5 0.5 0.5h14c0.28 0 0.5-0.22 0.5-0.5 0-2.39-1.47-4.43-3.6-5.52zm-8.1 2.02c-0.41 0-0.75-0.34-0.75-0.75s0.34-0.75 0.75-0.75 0.75 0.34 0.75 0.75-0.34 0.75-0.75 0.75zm7 0c-0.41 0-0.75-0.34-0.75-0.75s0.34-0.75 0.75-0.75 0.75 0.34 0.75 0.75-0.34 0.75-0.75 0.75zM7.5 18c0 0.83 0.67 1.5 1.5 1.5s1.5-0.67 1.5-1.5v-2h-3v2zm6 0c0 0.83 0.67 1.5 1.5 1.5s1.5-0.67 1.5-1.5v-2h-3v2z",
    fill: "#a4c639"
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-apple-logo",
    viewBox: "0 0 23 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7 2.6c0 1-0.4 2-1.1 2.8-0.8 0.9-2.1 1.6-3.2 1.5-0.1-1.1 0.4-2.2 1.1-3 0.8-0.9 2.2-1.6 3.2-1.3zM20.7 17.6c-0.4 0.9-0.8 1.7-1.4 2.5-0.8 1.1-1.7 2.2-3 2.2-1.2 0-1.5-0.7-3-0.7s-1.8 0.7-3 0.7c-1.3 0-2.2-1.1-3-2.2-1.7-2.4-3.1-6.7-1.3-9.6 0.9-1.5 2.5-2.4 4.2-2.4 1.1 0 2.1 0.7 3 0.7s2-0.7 3.1-0.7c1.7 0 3.1 0.9 4 2.4-0.1 0.1-2.7 1.1-2.7 4.1 0 3.2 2.7 4.2 2.7 4.2z",
    fill: "#fff"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-settings",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-time",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-stats",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14l3 -3l2 2l3 -3l2 2"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v3"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-gift",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8l0 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.622c8bd15cff8e73bf8e3d71ad4ee564.svg";
export { ForwardRef as ReactComponent };